'use client';

import { usePathname } from 'next/navigation';
import { useMemo } from 'react';

/**
 * Hook to get normalized path without locale
 */
export const usePathWithoutLocale = () => {
  const pathname = usePathname();

  const normalizedPath = useMemo(() => {
    if (!pathname) return '/';
    const parts = pathname.split('/').filter(Boolean);
    if (parts.length && parts[0].length === 2) {
      return `/${parts.slice(1).join('/')}`;
    }
    return pathname.startsWith('/') ? pathname : `/${pathname}`;
  }, [pathname]);

  return normalizedPath;
};

/**
 * Hook to check if a menu item is active
 * exact = true → only exact match
 * exact = false → main menu startsWith match
 */
export const useIsActiveMenuItem = (itemPath: string, exact = false) => {
  const currentPath = usePathWithoutLocale();

  return useMemo(() => {
    if (!currentPath || !itemPath) return false;

    const normalizedItem = itemPath.startsWith('/') ? itemPath : `/${itemPath}`;

    if (exact) {
      return currentPath === normalizedItem;
    }

    if (normalizedItem === '/') {
      return currentPath === '/';
    }

    return currentPath.startsWith(normalizedItem);
  }, [currentPath, itemPath, exact]);
};
